import { Injectable } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ConfirmDialogComponent, DialogService } from '@teammood/shared/ui/dialog';
import { Team } from '../team.type';
import { TeamDefaultsSettingsDialogComponent } from './team-defaults-settings-dialog/team-defaults-settings-dialog.component';
import { NewTeamDialogComponent } from './new-team-dialog/new-team-dialog.component';
import { TeamMembersImportDialogComponent } from './team-members-import-dialog/team-members-import-dialog.component';
import {TeamMembersExportDialogComponent} from "./team-members-export-dialog/team-members-export-dialog.component";
import { TranslateService } from '@ngx-translate/core';


@Injectable(
  { providedIn: 'root' }
)
export class TeamDialogService {
    constructor(
      private _dialogService: DialogService,
      private _translateService: TranslateService,
    ){}
  async teamDefaults(team: Team): Promise<MatDialogRef<TeamDefaultsSettingsDialogComponent, Team>> {
    return this._dialogService.open(TeamDefaultsSettingsDialogComponent, {
      width: '100%',
      maxWidth: '1250px',
      enterAnimationDuration: 0,
      exitAnimationDuration: 0,
      data: {
        team: team
      }
    })
  }

  async newTeam(team: Team, teamId: string): Promise<MatDialogRef<NewTeamDialogComponent, Team>> {
    return this._dialogService.open(NewTeamDialogComponent, {
      width: '100%',
      maxWidth: '1250px',
      enterAnimationDuration: 0,
      exitAnimationDuration: 0,
      data: {
        team: team,
        teamId: teamId
      }
    })
  }

  async delete(team: Team): Promise<MatDialogRef<ConfirmDialogComponent, boolean>> {
    return await this._dialogService.openConfirmDialog({
      title: this._translateService.instant('delete') + ` ${team.name} ?`,
      message: 'team_deletation_confirmation',
      confirmBtnLabel: 'delete',
      confirmBtnType: 'danger'
    });
  }

  async importTeamMembers(team: Team): Promise<MatDialogRef<TeamMembersImportDialogComponent, Team>> {
    return this._dialogService.open(TeamMembersImportDialogComponent, {
      width: '100%',
      maxWidth: '1250px',
      enterAnimationDuration: 0,
      exitAnimationDuration: 0,
      autoFocus: false,
      data: {
        team: team,
      }
    })
  }

  async exportTeamMembers(team: Team): Promise<MatDialogRef<TeamMembersExportDialogComponent, Team>> {
    return this._dialogService.open(TeamMembersExportDialogComponent, {
      width: '100%',
      maxWidth: '1250px',
      enterAnimationDuration: 0,
      exitAnimationDuration: 0,
      autoFocus: false,
      data: {
        team: team,
      }
    })
  }
}